import { useMutation } from '@tanstack/react-query';
import { signInInvestor } from 'services/api/auth-api.service';

export default function useSignInInvestor() {
  return useMutation({
    mutationFn: signInInvestor,
  });
}
